import { useDispatch, useSelector } from 'react-redux';
import { employeeActions } from '../reducers/employee.reducer';
import { AppDispatch } from '../store';
import { EmployeeState, RootState } from '../types/store.types';

export const useEmployeeStore = () => {
  const employeeStore = useSelector<RootState, EmployeeState>((state) => state.employee);
  const dispatch = useDispatch<AppDispatch>();

  const {
    getEmployeeList,
    getPayrollList,
    getEmployeeDetails,
    getPayrollDetails,
    handleSelectedBranch,
    handleSelectedEmployee,
    handleSelectedPosition,
    handleSetActive,
    getExtaPay,
    getBranchList,
    getSelectedDate,
    getDeductions,
    setEmployeeListLoading,
    setPayrollListLoading,
    getListOfItems,
    getPayrollPeriod,
    handleSelectedPayrollPeriod,
    getUpdateListById,
    getPayrollReportData,
    getPayrollReportFillterdData,
  } = employeeActions;

  return {
    dispatch,
    employeeStore,
    getEmployeeList,
    getPayrollList,
    getEmployeeDetails,
    getPayrollDetails,
    handleSelectedBranch,
    handleSetActive,
    getDeductions,
    getExtaPay,
    getBranchList,
    getSelectedDate,
    setEmployeeListLoading,
    setPayrollListLoading,
    getListOfItems,
    getPayrollPeriod,
    handleSelectedPayrollPeriod,
    getUpdateListById,
    getPayrollReportData,
    handleSelectedEmployee,
    handleSelectedPosition,
    getPayrollReportFillterdData,
  };
};
